import '../../estilos/paginas.css';
import { useEffect, useState } from 'react';
import { useNavigate, useParams, useLocation } from "react-router-dom";
import axios from "axios";
// componentes
import ZonaCargando from '../zonaCargando';
import RegistrarParaVer from './registrarParaVer';
import ContenedorTorneos from './contenedorTorneos';


function VerTorneos() {

  const navigate    = useNavigate();
  const location    = useLocation(); // cuando no se envía nada en state, location,state es null
  const routeParams = useParams();
  let { deporte }   = routeParams; // capturamos para paginación

  const [usuario, setUsuario]    = useState(null);
  const [torneos, setTorneos]    = useState(null);
  const [cargando, setCargando]  = useState(true);
  

  useEffect(() => {
    (async () => {
      try {
        setCargando(true);

        const verifToken  = axios.get("/verificar-token", { withCredentials: true });
        const pTorneos = axios.post("/obtener-torneos", { params: {deporte: deporte}  });
        

        const [ resVerif, resTorneos ] = await Promise.all([verifToken, pTorneos ]);
        setUsuario(resVerif.data.usuario);
        // torneo
        setTorneos(resTorneos.data.torneos);
      } 
      catch (err) { console.error("Error en una de las solicitudes:", err); } 
      finally { setCargando(false);}
    })();

    return ()=> {localStorage.setItem("paginaActual",1); }
  }, []);




  return(
    <div>
    {cargando ? <ZonaCargando /> :
    <div className='contenedorPaginasUsuario'>
      {/* Primer contenedor: imagen principal */}
      <div className='contenedorVERVIDEOS text-light'>
        <h1>Torneos de {deporte}</h1>
        <p className='subContenedorPrincipal'>Escoge el torneo que más te guste</p>
      </div>

      <ContenedorTorneos torneos={torneos} />

      {usuario ? null : <RegistrarParaVer />}
    </div>
    }
    </div>
  )
}



export default VerTorneos;